import { useTran } from "@/hooks";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";

const PillarSummaryChart = ({ data }) => {
  const { t } = useTran();
  const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload?.length) return null;
    const entry = payload[0].payload;
    return (
      <div className="rounded-lg border border-slate-300 bg-white p-3 shadow-lg">
        <p className="mb-1 font-semibold text-slate-900">
          {entry.pillarLabel || entry.pillar}
        </p>
        <p className="text-sm text-slate-600">
          {t("Total Disclosures")}:{" "}
          <span className="font-semibold">{entry.count}</span>
        </p>
        <p className="text-sm text-slate-600">
          {t("Completed")}:{" "}
          <span className="font-semibold">{entry.completed}</span>
        </p>
      </div>
    );
  };

  return (
    <div className="esg-chart-container">
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 20, right: 30, left: 100, bottom: 20 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#cbd5e1" />
          <XAxis
            type="number"
            stroke="#64748b"
            style={{ fontSize: "12px" }}
            label={{
              value: t("Number of Disclosures"),
              position: "insideBottom",
              offset: -10,
            }}
          />
          <YAxis
            type="category"
            dataKey="pillarLabel"
            stroke="#64748b"
            style={{ fontSize: "12px", fontWeight: 600 }}
            width={80}
          />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: "#f1f5f9" }} />
          <Bar dataKey="count" radius={[0, 4, 4, 0]} barSize={40}>
            {data.map((entry) => (
              <Cell key={entry.pillarKey || entry.pillar} fill={entry.color} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PillarSummaryChart;
